<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Izdelava obrazca</h1>
        
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
     <div id="formio"></div>
        


    
      
    </div>
</div> 

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex';
//import {FormRenderer} from 'v-form-builder'
import Vue from 'vue';
export default {
    name: "MyAdminProMaxComponent",
  props:['obrazecid'],
 //  components:{FormRenderer},
    data () {
        return {
             configuration: {},
             formInputData: {},
        }
    },
    created () {
       
    },
     mounted(){

    let fa = document.createElement('link');
    fa.setAttribute('href', 'https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css');
    fa.setAttribute('rel', 'stylesheet');
    document.head.appendChild(fa);
    let bs = document.createElement('link');
    bs.setAttribute('href', 'https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css');
    bs.setAttribute('rel', 'stylesheet');
    document.head.appendChild(bs);
    let cs = document.createElement('link');
    cs.setAttribute('href', 'https://cdn.form.io/formiojs/formio.full.min.css');
    cs.setAttribute('rel', 'stylesheet');
    document.head.appendChild(cs);

    
    /*let formio = document.createElement('script');
    formio.setAttribute('src', 'https://cdn.form.io/formiojs/formio.full.min.js');
    document.head.appendChild(formio);*/

    //this.vrniPoId({id:this.obrazecid}).then(
          //  ()=>{this.configuration=JSON.parse(this.certifikat.obrazecJson)});
        if(this.obrazecid)
            this.vrniPoId({id:this.obrazecid}).then(()=>{
                    console.log("anložil sem podatke");
                    Formio.createForm(document.getElementById('formio'),JSON.parse(this.certifikat.obrazecJson));
    }
    )
    

    },

    computed: {
         ...mapState('obrazec', ['certifikat']),
         
           },
    methods: {

        ...mapActions('obrazec', ['vrniPoId','saveOne']),
        shraniCertifikat: function(e,d){
             Vue.delete(this.certifikat, 'datumveljavnosti');
             Vue.delete(this.certifikat, 'datumizdaje');
             Vue.set(this.certifikat,'obrazecJson',JSON.stringify(this.configuration));
             this.saveOne();
    },
        
    }
};
</script>

